import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    paddingTop: '30px',
    // flex
  },
  card: {
    float: 'left',

    width: '45%',
    padding: '30px',
    marginBottom: '20px',
    marginLeft: '2.5%',
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
    marginBottom: '20px',
  },
  fieldLabel: {
    marginBottom: '10px',
  },
  switchStack: {
    marginBottom: '10px',
  },
  switchGroup: {},
  switch: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      // transition:
      //   duration: 200,
      // ,
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(255,255,255,.35) ',
      boxSizing: 'border-box',
    },
  },
  themeAndLogosGrid: {},
  themeSection: {
    marginTop: '20px',
    padding: '11px',
  },
  logosSection: {
    marginTop: '20px',
    height: '715px',
    padding: '11px',
  },
  dropzone: {
    zIndex: 1000,
    //background: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
    background: 'transparent',
    margin: '12px 20px 0px 25px',
    width: '100%',
    height: '200px',
    minHeight: '200px',
    maxHeight: '200px',
    borderRadius: '30px',
    '& .MuiDropzoneArea-textContainer': {
      '&>p': {
        fontSize: '0px',
        marginTop: '170px',
      },
    },
    '& .MuiDropzoneArea-icon': {
      display: 'none',
    },
  },
  dropAndImage: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 0',
    marginBottom: '15px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  circleIcon: {
    position: 'relative',
    bottom: '4px',
  },
  bulletLogin1: {
    display: 'flex',
  },
  bulletLogin2: {
    display: 'flex',
    marginLeft: '20px',
  },
  bulletLogin3: {
    display: 'flex',
    marginLeft: '20px',
  },
  bulletHeader1: {
    display: 'flex',
  },
  bulletHeader2: {
    display: 'flex',
    marginLeft: '20px',
  },
  bulletHeader3: {
    display: 'flex',
    marginLeft: '20px',
  },
  bulletFavicon1: {
    display: 'flex',
  },
  bulletFavicon2: {
    display: 'flex',
    marginLeft: '20px',
  },
  bulletFavicon3: {
    display: 'flex',
    marginLeft: '20px',
  },
  logoTextsLogin1: {
    fontSize: '18px',
    margin: '0 0 10px 5px',
    width: '250px',
  },
  logoTextsLogin2: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  logoTextsLogin3: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  logoTextsHeader1: {
    fontSize: '18px',
    margin: '0 0 10px 5px',
    width: '250px',
  },
  logoTextsHeader2: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  logoTextsHeader3: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  logoTextsFavicon1: {
    fontSize: '18px',
    margin: '0 0 10px 5px',
    width: '290px',
  },
  logoTextsFavicon2: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  logoTextsFavicon3: {
    fontSize: '12px',
    margin: '0 0 0 15px',
    width: '250px',
  },
  adminLoginLogo: {
    //display: 'flex',
    maxWidth: '160px',
    width: '100%',
    //margin: 'auto',
    position: 'absolute',
    marginLeft: '23.5%',
  },
  adminHeaderLogo: {
    //display: 'flex',
    maxWidth: '160px',
    width: '100%',
    //margin: 'auto',
    position: 'absolute',
    marginLeft: '23.5%',
  },
  adminFaviconLogo: {
    //display: 'flex',
    maxWidth: '80px',
    width: '100%',
    //margin: 'auto',
    position: 'absolute',
    marginLeft: '26%',
  },
  systemSettingsButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '45px',
  },
  saveButton: {
    marginRight: '40px',
  },
  btn: {
    marginTop: '10px',
    height: 20,
    padding: 10,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  accessDeny: {
    display: 'flex',
    flexDirection: 'column',
  },
  accessDenyText: {
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: '40px',
    padding: '400px 0 50px 0',
  },
  goHomeButton: {
    width: '200px',
    margin: 'auto',
  },
  requiredText: {
    color: theme.palette.error.main,
  },
  licenseField: {
    width: 180,
  },
  adminTextInput: {},
  defaultPermGroup: {
    margin: '22px 30px 12px 0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'cebter',
  },
  defaultPermText: {
    margin: '5px 0 0 0',
  },
  defaultPermSelect: {
    margin: '0 0 0 15px',
  },
}));

export default useStyles;
